import { delimiters } from '../shared/constants';
import { select } from '../shared/utils/dom';
/*
* Choice Inquiry
*/
export default function choice() {
  const el = select('[data-vue-app="choice"]');
  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      data: {
        sitefinityurl: "",
      },
      mounted() {
        this.sitefinityurl = this.$el.dataset.sitefinityurl;
      },
      methods: {
        cancelCurrentEnrollment() {
          Event.$emit('A11yDialogOpen', { dialogKey: 'confirm-choice-cancel' });
        },
        cancelPendingEnrollment() {
          Event.$emit('A11yDialogOpen', { dialogKey: 'confirm-pending-cancel' });
        },
        redirectToExplorePage() {
          // add which page to redirect
          location.href = `${this.sitefinityurl}${'choice'}`;
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/choice.js